import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedUnit, formatUnit } from '../format'
import { providerTypes, propTypes } from '../types'
import { METRIC, HYBRID, FEET, METERS, SHORT, YARDS, KILOMETERS, MILES } from '../constants'

export function getElevationTo ({ to, system }) {
  if (to) { return to }
  return (system === METRIC || system === HYBRID) ? METERS : FEET
}

export function formatElevation ({ from = METERS, unit = SHORT, digits = 1, to: _to, system, ...rest }) {
  const to = getElevationTo({ from, to: _to, system })
  return formatUnit({ ...rest, from, to, unit, digits })
}

export function elevationFormatter ({ intl, locale, system }) {
  return ({ ...options }) => formatElevation({ ...options, intl, locale, system })
}

export class FormattedElevation extends Component {
  static contextTypes = providerTypes;

  static propTypes = {
    ...propTypes,
    from: PropTypes.oneOf([ FEET, YARDS, METERS, KILOMETERS, MILES ]),
    to: PropTypes.oneOf([ FEET, YARDS, METERS, KILOMETERS, MILES ]),
  };

  static defaultProps = {
    from: METERS,
    unit: SHORT,
    digits: 1,
  }

  render () {
    const { to: _to, ...rest } = this.props
    const to = getElevationTo({ to: _to, system: this.context.system })
    return React.createElement(FormattedUnit, { ...rest, to })
  }
}
